import React from "react";

const LabelImage = (props) => {
  return (
    <div>
      <img
        src={props.url}
        alt={props.name}
        style={{ height: props.height || "40px" }}
      />{" "}
      {props.name}
    </div>
  );
};

export default LabelImage;
